module.exports = __webpack_public_path__ + "img/pr-3.d6d038ec.png";